<template>
  <button
    :aria-label="ariaLabel"
    :class="buttonPlayClasses"
    @click="onPlay"
    @keydown="onPlaySpace"
    tabindex="0"
  >
    <Icon name="audio" :size="size" :color="colorIcon" focusable="false" />
  </button>
</template>

<script>
import { Howl, Howler } from 'howler';
import { Icon } from '../Icon';

export default {
  name: 'VoiceOver',
  components: { Icon },
  props: {
    bgColor: {
      type: String,
      required: false,
    },
    bgColorHover: {
      type: String,
      required: false,
    },
    colorIcon: {
      type: String,
      required: false,
    },
    size: {
      type: [String, Number],
      default: '1em',
    },
    btnOutlineColor: {
      type: String,
      default: 'black',
    },
    ariaLabel: {
      type: String,
      default: 'Speaker',
    },
    src: {
      type: String,
    },
  },
  data() {
    return {
      player: null,
      newSrc: null,
      isPlaying: false,
    };
  },
  mounted() {
    this.player = new Howl({
      src: [this.src],
      html5: true,
      preload: true,
    });
    this.player.on('end', () => {
      this.onSetNewSrc();
      this.$emit('on-complete');
    });
    this.player.on('stop', () => {
      if (!this.isPlaying) {
        this.onSetNewSrc();
      }
    });
  },

  methods: {
    onPlaySpace(e) {
      e.stopPropagation();
      if (e.keyCode === 32) {
        e.preventDefault();
        this.handlePlay();
      }
    },
    onPlay(e) {
      e.stopPropagation();
      this.handlePlay();
    },
    handlePlay() {
      if (!this.player.playing()) {
        this.isPlaying = true;
        Howler.stop();
        this.onSetNewSrc();
        this.player.play();
        this.$emit('on-play');
      } else {
        this.onStop();
      }
    },
    onStop() {
      this.isPlaying = false;
      this.player.stop();
    },
    setSrc(newSrc) {
      if (this.player) {
        Howler.stop();
        this.player._src = newSrc;
        let sounds = this.player._sounds;
        sounds[0]._node.src = newSrc;
        this.player.load();
      }
    },
    onSetNewSrc() {
      if (this.newSrc) {
        this.setSrc(this.newSrc);
        this.newSrc = null;
      }
    },
  },
  computed: {
    buttonPlayClasses() {
      const btnPlayAudioClass = {
        'button--play-audio': true,
      };

      btnPlayAudioClass[`bg-${this.bgColor}`] = !!this.bgColor;
      btnPlayAudioClass[`bg-${this.bgColorHover}-hover`] = !!this.bgColorHover;
      btnPlayAudioClass[`outline-${this.btnOutlineColor}`] =
        !!this.btnOutlineColor;

      return {
        ...btnPlayAudioClass,
      };
    },
  },
  beforeDestroy() {
    if (this.player.playing()) {
      this.onStop();
    }
  },
  watch: {
    src: {
      immediate: true,
      handler: function (newValueSrc, oldValueSrc) {
        if (oldValueSrc && newValueSrc !== oldValueSrc) {
          this.newSrc = newValueSrc;
        }
      },
    },
  },
};
</script>

<style lang="stylus" scoped>

.button--play-audio
  border none
  padding 0.6rem
  text-align center
  cursor pointer
  font-size 1.3em
  width 2.164em
  height 2.164em

  &:hover
  &:focus
    transform scale(1.1)

::v-deep
  .icon
    position relative
    right 1.2px
    bottom 1.2px
</style>
